"use client";

import { useState } from "react";
import { InputWithLabel } from "@/app/components/ui/input";
import { AuthErrorContainer } from "../../../components/auth-error-container";
import { ResendConfirmationButton } from "./resend-confirmation-button";
import { resendSignupConfirmationAction } from "@/app/services/server/actions/auth/resend-signup-confirmation";

/**
 * Requests a fresh signup confirmation mail.
 *
 * On success the form is replaced by the confirmation notice: the answer is
 * deliberately neutral, so leaving the form around would invite people to
 * hammer it and run into the hourly mail cap.
 */
export function ResendConfirmationForm() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const handleSubmit = async (formData: FormData) => {
    setError(null);

    try {
      const result = await resendSignupConfirmationAction(formData);

      if (result.success) {
        setSuccessMessage(result.message ?? null);
      } else {
        setError(result.error ?? "Die E-Mail konnte nicht verschickt werden.");
      }
    } catch (submitError) {
      console.error("Failed to resend confirmation:", submitError);
      setError("Ein unerwarteter Fehler ist aufgetreten.");
    }
  };

  if (successMessage) {
    return (
      <div className="rounded-[11px] border border-[var(--c-border-strong)] bg-[var(--c-surface)] p-4 text-sm leading-relaxed">
        {successMessage}
      </div>
    );
  }

  return (
    <form action={handleSubmit} className="flex flex-col gap-4">
      <div>
        <InputWithLabel
          name="email"
          label="E-Mail-Adresse"
          aria-label="E-Mail-Adresse"
          autoComplete="email"
          type="email"
          id="email"
          required
          aria-invalid={!!error}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </div>

      {error && <AuthErrorContainer error={error} />}

      <ResendConfirmationButton disabled={email.trim().length === 0} />
    </form>
  );
}
